module.exports = __webpack_public_path__ + "img/002_thumbnail.deb40dce.jpg";